import { useEffect, useRef, useState } from "react";

export interface TabIndicator {
  left: number;
  width: number;
}

interface Props {
  selected: string;
}

const useTabIndicatorPosition = ({ selected }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const buttonRefs = useRef<Map<string, HTMLButtonElement>>(new Map());
  const [indicator, setIndicator] = useState<TabIndicator>({
    left: 0,
    width: 0,
  });

  useEffect(() => {
    const container = containerRef.current;
    const button = buttonRefs.current.get(selected);
    if (!container || !button) return;

    const containerRect = container.getBoundingClientRect();
    const buttonRect = button.getBoundingClientRect();

    setIndicator({
      left: buttonRect.left - containerRect.left,
      width: buttonRect.width,
    });
  }, [selected]);

  return {
    containerRef,
    buttonRefs,
    indicator,
  };
};

export default useTabIndicatorPosition;
